/* AIBOOKS · interacciones de la tienda */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Buscador desplegable
  const sBtn = $('[data-aib-search]'), sBar = $('[data-aib-searchbar]');
  if (sBtn && sBar) sBtn.addEventListener('click', () => {
    const on = sBar.classList.toggle('on');
    sBtn.setAttribute('aria-expanded', String(on));
    if (on) { const i = $('input[type=search]', sBar); i && i.focus(); }
  });

  // Mega menú: cerrar al hacer clic fuera o con Escape
  const mm = $('[data-aib-mm]');
  if (mm) {
    document.addEventListener('click', e => { if (mm.open && !mm.contains(e.target)) mm.open = false; });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') mm.open = false; });
  }
  // Menú móvil
  const close = $('[data-aib-close]');
  if (close) close.addEventListener('click', () => { const d = close.closest('details'); if (d) d.open = false; });
  $$('.drawer').forEach(d => d.addEventListener('toggle', () => { document.documentElement.style.overflow = d.open ? 'hidden' : ''; }));

  // Filtros por tema en estanterías
  $$('[data-aib-chips]').forEach(group => {
    const grid = group.parentElement.querySelector('[data-aib-grid]');
    $$('.chip', group).forEach(c => c.addEventListener('click', () => {
      const f = c.dataset.f;
      $$('.chip', group).forEach(x => x.setAttribute('aria-pressed', String(x === c)));
      if (grid) $$('.card', grid).forEach(card => { card.hidden = !(f === 'all' || card.dataset.cat === f); });
    }));
  });

  // Ordenar colección
  $$('[data-aib-sort] select').forEach(s => s.addEventListener('change', () => s.form.submit()));

  // Galería de producto
  const gal = $('[data-aib-gal]');
  if (gal) {
    const main = $('[data-aib-main]', gal);
    $$('.thumbs button', gal).forEach(b => b.addEventListener('click', () => {
      if (!main) return;
      main.style.opacity = '.3';
      const img = new Image();
      img.onload = () => { main.src = b.dataset.src; main.removeAttribute('srcset'); main.alt = b.dataset.alt || main.alt; main.style.opacity = '1'; };
      img.src = b.dataset.src;
      $$('.thumbs button', gal).forEach(x => x.setAttribute('aria-current', String(x === b)));
    }));
  }

  // Barra fija de compra en móvil
  const sticky = $('[data-aib-sticky]'), box = $('#comprar');
  if (sticky && box && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => sticky.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(box);
  }

  // Añadir a la cesta sin salir de la página
  const toast = $('[data-aib-toast]');
  let tt;
  function showToast(name, img) {
    if (!toast) return;
    $('[data-aib-toast-t]', toast).textContent = 'Añadido a tu cesta';
    $('[data-aib-toast-s]', toast).textContent = name || '';
    const im = $('[data-aib-toast-img]', toast);
    if (im && img) im.src = img;
    toast.classList.add('on');
    clearTimeout(tt); tt = setTimeout(() => toast.classList.remove('on'), 4200);
  }
  function setCount(n) {
    $$('[data-aib-count]').forEach(el => { el.textContent = n; el.dataset.zero = String(n === 0); });
  }
  $$('form[data-aib-add]').forEach(f => f.addEventListener('submit', async e => {
    if (!window.fetch) return;
    if (e.submitter && e.submitter.name === 'return_to') return; // «Comprar ahora» va directo al pago
    e.preventDefault();
    const btn = f.querySelector('button[type=submit]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo…'; }
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) });
      if (!r.ok) throw new Error('add');
      const c = await (await fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })).json();
      setCount(c.item_count);
      showToast(btn && btn.dataset.name, btn && btn.dataset.img);
      if (btn) { btn.classList.add('ok'); btn.textContent = '✓ Añadido'; setTimeout(() => { btn.classList.remove('ok'); btn.textContent = label; }, 2200); }
    } catch (err) {
      f.removeAttribute('data-aib-add'); f.submit();
    } finally {
      if (btn) btn.disabled = false;
    }
  }));
})();
